import { Component, EventEmitter, inject, Output } from '@angular/core';
import * as XLSX from 'xlsx';
import { exportArrayToExcel } from 'src/app/shared/utils';
import { SmartAssistantImportService } from '../smart-assistant-import.service';

@Component({
    standalone: false,
    selector: 'app-smart-assistant-upload-step',
    templateUrl: './smart-assistant-upload-step.component.html'
})
export class SmartAssistantUploadStepComponent {
    @Output() fileSelected = new EventEmitter<File | null>();

    readonly service = inject(SmartAssistantImportService);

    fileChanged(files: File[]): void {
        const file = files?.[0] ?? null;
        this.fileSelected.emit(file);

        if (!file) {
            this.service.updateFileHeaders([]);
            return;
        }

        const reader = new FileReader();
        reader.onload = (e: ProgressEvent<FileReader>) => {
            try {
                const data = new Uint8Array(e.target?.result as ArrayBuffer);
                const workbook = XLSX.read(data, { type: 'array', sheetRows: 1 });
                const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
                const rows = XLSX.utils.sheet_to_json<string[]>(firstSheet, { header: 1 });
                const headers = (rows[0] ?? []).map((header) => String(header).trim()).filter((header) => header.length > 0);

                if (headers.length === 0) {
                    this.service.updateFileError($localize`The file does not contain any column headers.`);
                    return;
                }

                this.service.updateFileHeaders(headers);
            } catch {
                this.service.updateFileError($localize`The file could not be read. Please upload a valid Excel file.`);
            }
        };
        reader.readAsArrayBuffer(file);
    }

    downloadTemplateFile(requiredColumnLabels: string[], optionalColumnLabels: string[]): void {
        const allColumns = [...(requiredColumnLabels ?? []), ...(optionalColumnLabels ?? [])];
        const templateRow: { [key: string]: string } = {};
        allColumns.forEach((label) => {
            templateRow[label] = '';
        });
        exportArrayToExcel([templateRow], 'template');
    }
}
